<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronLeft_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m13.793 17.707-5-5a1 1 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L10.914 12l4.293 4.293a.999.999 0 1 1-1.414 1.414"
    />
</svg>
